import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { FC } from 'react';

import { YearNumberField } from '../general/components/yearNumberField';
import { AboutFormControlProps } from '../types';

import { CheckboxArea } from './components/checkboxArea';

export const Ved: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue, getValues } = useFormContext();
  const energimerkeversjon = getValues('energimerkeversjon');
  return (
    <Controller
      control={control}
      name="oppvarmingSelection.oppvarmingVed"
      render={({ field: { value, onChange } }) => (
        <CheckboxArea
          onChange={(checked: boolean) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingVed`, undefined);
            }
          }}
          i18nPrefix="register.tekniskUtstyr.oppvarmingVed"
          i18nPostfix={energimerkeversjon}
          value={!!value}
        >
          <Box p={3} gap={3} display="flex" flexDirection="column">
            <Controller
              control={control}
              name="oppvarming.oppvarmingVed.installasjonsArApenPeis"
              render={({ field, fieldState }) => (
                <YearNumberField
                  error={fieldState.error}
                  value={field.value}
                  onChange={field.onChange}
                  labelKey="register.tekniskUtstyr.installasjonsArApenPeis.label"
                  informationKey="register.tekniskUtstyr.installasjonsArApenPeis.information"
                />
              )}
            />
            <Controller
              control={control}
              name="oppvarming.oppvarmingVed.installasjonsArLukketOvn"
              render={({ field, fieldState }) => (
                <YearNumberField
                  error={fieldState.error}
                  value={field.value}
                  onChange={field.onChange}
                  labelKey="register.tekniskUtstyr.installasjonsArLukketOvn.label"
                  informationKey="register.tekniskUtstyr.installasjonsArLukketOvn.information"
                />
              )}
            />
            <Controller
              control={control}
              name="oppvarming.oppvarmingVed.installasjonsArPeisMedDor"
              render={({ field, fieldState }) => (
                <YearNumberField
                  error={fieldState.error}
                  value={field.value}
                  onChange={field.onChange}
                  labelKey="register.tekniskUtstyr.installasjonsArPeisMedDor.label"
                  informationKey="register.tekniskUtstyr.installasjonsArPeisMedDor.information"
                />
              )}
            />
          </Box>
        </CheckboxArea>
      )}
    />
  );
};
